import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Select, MenuItem } from "@material-ui/core";
import InformationPopup from "../components/InformationPopup";
import { mapEdgesToNodes } from "../../../lib/helpers";

const VitalValues = ({
  vitalvalues,
  handleVitalvalues,
}) => {

  const data = useStaticQuery(graphql`
    query VitalValuesQuery {
      vitalInfo: allSanityVitalValueInfo {
        edges {
          node {
            id
            title
            bodyTempInfoPopUp {
              _type
              title
              youtubeVideoId
            }
            _rawBreathInfoPopUp
            glandsInfoPopUp {
              _type
              title
              glandsImages {
                _key
                _type
                images {
                  asset {
                    id
                    url
                    # fluid {
                    #   base64
                    #   aspectRatio
                    #   src
                    #   srcSet
                    #   srcWebp
                    #   srcSetWebp
                    #   sizes
                    # }
                    _id
                  }
                  hotspot {
                    _key
                    _type
                    x
                    y
                    height
                    width
                  }
                  crop {
                    _key
                    _type
                    top
                    bottom
                    left
                    right
                  }
                  alt
                  caption
                }
              }
            }
          }
        }
      }
    }
  `);

const infos = (data || {}).vitalInfo ? mapEdgesToNodes(data.vitalInfo) : [];

  return (
    <>
      <div className="formStep--wrapper">
        <h2>Überprüfung einiger Vitalwerte</h2>
        <div className="vitalValues__grid">
          <div>
            <div className="vitalValues__labelGrid">
              <h4 className="vitalValues__labelGrid--label">Körpertemperatur</h4>
              <div className="vitalValues__labelGrid--information">
                <InformationPopup
                  isTemp
                  title={infos[0].bodyTempInfoPopUp.title}
                  youtubeId={infos[0].bodyTempInfoPopUp.youtubeVideoId}
                />
              </div>
            </div>

            <Select
              className="select"
              autoWidth
              variant="outlined"
              name="bodyTemp"
              labelId="bodyTemp-label"
              id="bodyTemp"
              value={vitalvalues.bodyTemp}
              onChange={handleVitalvalues}
            >
              <MenuItem value={0}>Nicht bestimmt</MenuItem>
              <MenuItem value={1}>&lt;37,0 &#8451;</MenuItem>
              <MenuItem value={2}>37-39,1 &#8451;</MenuItem>
              <MenuItem value={3}>39,1-39,6 &#8451;</MenuItem>
              <MenuItem value={4}>&gt;39,6 &#8451;</MenuItem>
            </Select>
          </div>

          <div>
            <div className="vitalValues__labelGrid">
              <h4 className="vitalValues__labelGrid--label">Farbe Schleimhäute</h4>
              <div className="vitalValues__labelGrid--information">
                <InformationPopup
                  title={infos[0].glandsInfoPopUp.title}
                  glandsImages={infos[0].glandsInfoPopUp.glandsImages.images}
                  isGlands={true}
                />
              </div>
            </div>
            <Select
              className="select"
              autoWidth
              variant="outlined"
              name="glandColor"
              labelId="glandColor-label"
              id="glandColor"
              value={vitalvalues.glandColor}
              onChange={handleVitalvalues}
            >
              <MenuItem value="nicht bestimmt">Nicht bestimmt</MenuItem>
              <MenuItem value="Rosa">Rosa</MenuItem>
              <MenuItem value="weakRosa">Blass Rosa</MenuItem>
              <MenuItem value="red">Rötlich</MenuItem>
              <MenuItem value="blue">Bläulich</MenuItem>
              <MenuItem value="porcelainWhite">Porzellanweiß</MenuItem>
            </Select>
          </div>

          <div>
            <div className="vitalValues__labelGrid">
              <h4 className="vitalValues__labelGrid--label">Atemfrequenz</h4>
              <div className="vitalValues__labelGrid--information">
                <InformationPopup
                  isBreathing
                  title={infos[0]._rawBreathInfoPopUp.title}
                  body={infos[0]._rawBreathInfoPopUp.bodyText}
                />
              </div>
            </div>

            <Select
              className="select"
              autoWidth
              variant="outlined"
              name="breathFreq"
              labelId="breathFreq-label"
              id="breathFreq"
              value={vitalvalues.breathFreq}
              onChange={handleVitalvalues}
            >
              <MenuItem value={0}>Nicht bestimmt</MenuItem>
              <MenuItem value={1}>Nicht zählbar, da Tier ununterbrochen hechelt</MenuItem>
              <MenuItem value={2}>&lt;30/min</MenuItem>
              <MenuItem value={3}>30-40/min</MenuItem>
              <MenuItem value={4}>&gt;40/min</MenuItem>
            </Select>
          </div>
        </div>
      </div>
    </>
  );
};

export default VitalValues;
